import { Component, Input, OnChanges } from '@angular/core';
import { VoltageSpeedDataQuality } from '../../voltage-with-speed.models';
import { buildDataQuality } from './data-quality.utils';

@Component({
  selector: 'app-voltage-speed-data-quality',
  templateUrl: './data-quality.component.html',
  styleUrls: ['./data-quality.component.css']
})
export class VoltageSpeedDataQualityComponent implements OnChanges {
  @Input() quality: VoltageSpeedDataQuality | null = null;

  view = buildDataQuality(null);

  ngOnChanges(): void {
    this.view = buildDataQuality(this.quality);
  }
}
